import { Box } from '@mui/material';

export default function ChoiceChip({ selected, children, onClick, type = 'button', sx, ...props }) {
    return (
        <Box
            component="button"
            type={type}
            onClick={onClick}
            aria-pressed={selected}
            sx={{ ...styles.base, ...(selected ? styles.selected : null), ...sx }}
            {...props}
        >
            {children}
        </Box>
    );
}

const styles = {
    base: {
        font: 'inherit',
        fontWeight: 600,
        fontSize: '0.85rem',
        padding: '0.5rem 0.9rem',
        borderRadius: '6px',
        border: '1.5px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        color: 'text.primary',
        cursor: 'pointer',
        transition: 'border-color .15s ease-out, background-color .15s ease-out, color .15s ease-out',
        '&:hover': {
            borderColor: 'secondary.main',
        },
        '&:focus-visible': {
            outline: '2px solid',
            outlineColor: 'secondary.main',
            outlineOffset: 2,
        },
    },
    selected: {
        borderColor: 'secondary.main',
        bgcolor: 'secondary.light',
        color: 'secondary.dark',
    },
};
